/**
 * 前台接口
 * 2021.04.15
 */

import request from '@/utils/request'
import qs from "querystring";



/**
 * 获取轮播图
 * @param {array} params 请求数据
 */
export function getSwipe(params) {
  return request({
    url: '/api/index/swipe',
    method: 'get',
    params
  })
}

/**
 * 获取折扣商品
 * @param {array} params 请求数据
 */
 export function getDisShop(params) {
  return request({
    url: '/api/index/discount',
    method: 'get',
    params
  })
}

/**
 * 获取商品列表
 * @param {array} params 请求数据
 */
 export function getShop(params) {
  return request({
    url: '/api/index/shop',
    method: 'get',
    params
  })
}

/**
 * 获取单个商品
 * @param {array} params 请求数据
 */
 export function getSingleShop(params) {
  return request({
    url: '/api/details/shop',
    method: 'get',
    params
  })
}

/**
 * 获取基础设置
 * @param {array} params 请求数据
 */
 export function getSystem(params) {
  return request({
    url: '/api/index/system',
    method: 'get',
    params
  })
}
/**
 * 获取折扣信息
 * @param {array} params 请求数据
 */
 export function getDiscount(params) {
  return request({
    url: '/api/details/discount',
    method: 'get',
    params
  })
}

/**
 * 创建订单
 * @param {array} data 请求数据
 */
 export function postSubmit(data) {
  return request({
    url: '/api/pay/submit',
    method: 'post',
    data
  })
}

/**
 * 查询订单信息
 * @param {array} params 请求数据
 */
 export function getOrder(params) {
  return request({
    url: '/api/pay/order',
    method: 'get',
    params
  })
}

/**
 * 查询订单状态
 * @param {array} params 请求数据
 */
 export function getStatus(params) {
  return request({
    url: '/api/pay/status',
    method: 'get',
    params
  })
}

/**
 * 提交支付
 * @param {array} data 请求数据
 */
 export function postPay(data) {
  return request({
    url: '/api/pay',
    method: 'post',
    data
  })
}

/**
 * 查询订单
 * @param {array} params 请求数据
 */
 export function getQuery(params) {
  return request({
    url: '/api/index/query',
    method: 'get',
    params
  })
}
/**
 * 获取销量商品
 * @param {array} params 请求数据
 */
 export function getSalesShop(params) {
  return request({
    url: '/api/index/sales',
    method: 'get',
    params
  })
}
/**
 * 获取分类商品列表
 * @param {array} params 请求数据
 */
 export function getGroupShop(params) {
  return request({
    url: '/api/index/group_shop',
    method: 'get',
    params
  })
}

/**
 * 获取分类列表
 * @param {array} params 请求数据
 */
 export function getGroup(params) {
  return request({
    url: '/api/group',
    method: 'get',
    params
  })
}

